import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';

export default function AdminRoute({ children }) {
  const { user, isAdmin, loading, logout } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="auth-loading">
        <div className="auth-loading__spinner" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  if (!isAdmin) {
    return (
      <div className="auth-loading">
        <p style={{ color: 'var(--muted)', textAlign: 'center', marginBottom: '1rem' }}>
          Kein Zugriff. Bitte wende dich an einen Administrator.
        </p>
        <button
          onClick={async () => { await logout(); navigate('/admin/login'); }}
          style={{
            background: 'transparent',
            border: '1px solid var(--border)',
            borderRadius: '8px',
            color: 'var(--muted)',
            cursor: 'pointer',
            fontSize: '0.9rem',
            padding: '0.5rem 1.25rem',
          }}
        >
          Abmelden
        </button>
      </div>
    );
  }

  return children;
}
